export const SET_SIDENAVIGATION = 'SET_SIDENAVIGATION';
